import { Navigate } from 'react-router-dom';
import { lePerfilDoUsuario } from '../../apis/auth/sessaoDoUsuario';

interface ProtectedRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  /**
   * Perfis com acesso à rota. Quando informado, quem não estiver na lista volta para a home.
   * O menu já esconde os cards por perfil, mas isso não impede digitar a URL direto.
   */
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, isAuthenticated, allowedRoles }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(lePerfilDoUsuario() ?? '')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
